module.exports = require('./lib/Observable.js').Observable;



//////////////////
// WEBPACK FOOTER
// /builds/development/frontend/widgets/widgets/node_modules/zen-observable-ts/node_modules/zen-observable/index.js
// module id = ../../node_modules/zen-observable-ts/node_modules/zen-observable/index.js
// module chunks = widget-7.1.6